import React, { useEffect, useState } from 'react';
import { useTheme, ITheme } from 'src/theme';
import { css } from '@linaria/core';
import { get } from 'lodash';
import { GAAviva } from '@utils/gaAviva';

import { LeftGrid, ContainerGrid, Container } from '@components/LayoutGrid';
import Heading from '@components/Heading';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Button from '@components/Button';

const fluidBox = css`
  margin-top: -40px!important;
`;


const trackOnload = (): void => {
  const GA = GAAviva.getInstance();
  let { form, acquisition } = GA.digitalData;
  form.name = 'Contact';
  GA.trackPageLoad({ form, acquisition });
}


export interface ContactProps { }

function Contact(props: ContactProps) {
  const theme: ITheme = useTheme();
  const [isPageLoaded, setIsPageLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!isPageLoaded) {
      trackOnload();
      setIsPageLoaded(true);
    }
  }, [isPageLoaded]);

  const backToHomePage = () => {
    const aviaWebsite = get(window, 'AVIVA_VARIABLE_CONFIG.avivaWebsiteUrl');
    window.open(aviaWebsite, '_self');
  }

  return (
    <Container>
      <ContainerBlock className={fluidBox} background={theme.colors.secondary} padding="40px 20px" paddingTablet="80px 0 80px 30px">
        <ContainerGrid>
          <LeftGrid>
            <Heading fontWeight={600} color={theme.colors.white} margin="0 0 10px"> Thank you for your interest in this plan.  </Heading>
            <Heading variant="label" color={theme.colors.white} fontWeight={300}> We’re unable to proceed with your online quotation request.  </Heading>
          </LeftGrid>
        </ContainerGrid>
      </ContainerBlock>
      <ContainerGrid>
        <LeftGrid>
          <Heading variant="label" color={theme.colors.grey[300]} margin="0 0 30px"> Please visit us in person at our Customer Service Centre for further assistance. Thank you.  </Heading>
          <Text color={theme.colors.grey[500]} fontWeight={600} margin="0 0 5px">Address: </Text>
          <Text>5 Straits View</Text>
          <Text>#01-18/19</Text>
          <Text>Marina One The Heart</Text>
          <Text margin="0 0 30px">Singapore 018935</Text>
          <Text color={theme.colors.grey[500]} fontWeight={600} margin="0 0 5px">Mondays to Fridays: </Text>
          <Text margin="0 0 30px">8.45am to 5.30pm </Text>
          <Text color={theme.colors.grey[500]} fontWeight={600} margin="0 0 5px">Saturdays, Sundays & Public Holidays: </Text>
          <Text margin="0 0 40px">Closed </Text>
          <Button margin="0 0 40px" label="Back to homepage" onClick={backToHomePage}></Button>
        </LeftGrid>

      </ContainerGrid>

    </Container>
  );
};

export default Contact;
